export default class VerifyCodeData {
    constructor(
        public code: number,
        public rememberedSelected: boolean,
    ) { }
}